import { notify } from "@kyvg/vue3-notification";
import http from "@/utils/axios";
import { apiPaths } from "@/dictionaries/api/paths";

export default {
  namespaced: true,
  state: {
    discountCodes: [],
    types: [],
    generateCodeTypes: [],
    pagination: {
      currentPage: 1,
      total: 1,
    },
  },
  getters: {
    getDiscountCodes: (state) => state.discountCodes,
    getTypes: (state) => state.types,
    getGenerateCodeTypes: (state) => state.generateCodeTypes,
    getPagination: (state) => state.pagination,
  },
  mutations: {
    setDiscountCodes(state, payload) {
      state.discountCodes = payload.data;
      state.pagination.currentPage = payload.meta.current_page;
      state.pagination.total = payload.meta.last_page;
    },
    toggleActivePromotion(state, payload) {
      const discountCode = state.discountCodes.find(
        (item) => item.id === payload
      );
      if (discountCode) {
        discountCode.is_active = !discountCode.is_active;
      }
    },
    setTypes(state, payload) {
      state.types = payload;
    },
    setGenerateCodeTypes(state, payload) {
      state.generateCodeTypes = payload;
    },
    setCurrentPage(state, currentPage) {
      state.pagination.currentPage = currentPage;
    },
  },
  actions: {
    async fetchDiscountCodes({ commit, state }) {
      const { data } = await http.get(apiPaths.admin.discountCode.exact, {
        params: {
          page: state.pagination.currentPage,
        },
      });
      commit("setDiscountCodes", data.discountCodes);
    },
    async fetchDiscountCodeTypes({ commit }) {
      const { data } = await http.get(apiPaths.admin.discountCode.create);
      commit("setTypes", data.types);
      commit("setGenerateCodeTypes", data.generateCodeTypes);
    },
    async toggleActivePromotion({ commit }, payload) {
      commit("toggleActivePromotion", payload);
      await http.put(`${apiPaths.admin.discountCode.toggleActive}/${payload}`);
    },
    async downloadCodes({ commit }, url) {
      commit("setLoadingRaports", true);
      await http({
        url: url,
        method: "GET",
      })
        .then((response) => {
          commit("clearErrors");
          const filename =
            response.headers["content-disposition"].split("filename=")[1];
          const url = window.URL.createObjectURL(new Blob([response.data]));
          let link = document.createElement("a");
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          setTimeout(() => {
            URL.revokeObjectURL(url);
            link.remove();
          }, 1000);
          commit("setLoadingRaports", false);
        })
        .catch(({ response }) => {
          commit("setLoadingRaports", false);
          if (response && response.status === 422) {
            commit("setErrors", response.data.errors);
            notify({
              type: "danger",
              text: "messages.download.failure",
              duration: 5000,
            });
          } else if (response && response.status === 403) {
            notify({
              type: "danger",
              text: "messages.permission.failure",
              duration: 5000,
            });
          } else {
            notify({
              type: "danger",
              text: "messages.download.failure",
              duration: 5000,
            });
          }
        });
    },
  },
};
